/**
 * Companies API Service
 *
 * Handles all company-related API calls.
 * Matches FastAPI backend snake_case conventions.
 */

import { api } from '../client';

export const companiesService = {
  /**
   * Get all companies
   * @returns {Promise<Array>} Array of companies
   */
  async getAll() {
    const response = await api.post('/api/company', {});
    return response || [];
  },

  /**
   * Get a single company by ID
   * @param {string} companyId - Company ID
   * @returns {Promise<Object>} Company details
   */
  async getById(companyId) {
    const response = await api.post('/api/company', { _id: companyId });
    return response[0]; // API returns array
  },

  /**
   * Create a new company
   * @param {Object} companyData - Company data (contact_email, contact_phone, etc.)
   * @returns {Promise<Object>} Created company
   */
  async create(companyData) {
    return await api.put('/api/company', companyData);
  },

  /**
   * Update an existing company
   * @param {string} companyId - Company ID
   * @param {Object} updates - Fields to update
   * @returns {Promise<Object>} Updated company
   */
  async update(companyId, updates) {
    return await api.patch('/api/company', {
      query: { _id: companyId },
      update_data: updates,
    });
  },

  /**
   * Delete a company
   * @param {string} companyId - Company ID
   * @returns {Promise<Object>} Deletion response
   */
  async delete(companyId) {
    return await api.delete('/api/company', {
      data: { _id: companyId },
    });
  },
};
